import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../ui-core/Button/Button';
import ModalBox from '../../ui-core/Modal';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';

import './style.css';

const ErrorModal = ({
  isLoading,
  handleClose,
  handleCourseRedirection,
  page,
  show,
}) => {
  const handleTryAgain = () => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      page,
      section_title: 'Challenge Error Modal',
      button_title: 'TRY AGAIN',
    });
    handleCourseRedirection();
  };
  return (
    <ModalBox
      show={show}
      handleClose={handleClose}
      dialogClassName={'error-modal'}
    >
      <div className="p-4 text-center">
        <h2>Oops something went wrong, please try again</h2>
        <Button
          class="folder-save-btn w-100 d-flex align-items-center justify-content-around crt-fldr"
          isLoading={isLoading}
          isDisabled={isLoading}
          onClick={handleTryAgain}
          text={'TRY AGAIN'}
        />
      </div>
    </ModalBox>
  );
};

ErrorModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleCourseRedirection: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  page: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default ErrorModal;
